/* The shipping box (snippets/tso-shipping-info) as an element, <tso-shipping-info>.

   In the cart drawer and on the cart page the section around the box is re-rendered on every cart
   change, and the box comes along with it. On product pages nothing re-renders it, so a box with
   data-refresh-url (context 'product') fetches itself again through the Section Rendering API
   (sections/tso-ship-info-pdp) whenever the cart changes: theme.pubsub cartUpdate, published by every
   cart change in this theme, and cart:refresh from cart code outside it (the Death Row casket).
   A burst of both (the theme's add-to-cart can send both) gives one fetch. */
if (!customElements.get('tso-shipping-info')) {
  customElements.define(
    'tso-shipping-info',
    class TsoShippingInfo extends HTMLElement {
      connectedCallback() {
        this.refreshUrl = this.getAttribute('data-refresh-url');
        if (!this.refreshUrl) return;

        this.onCartChange = this.onCartChange.bind(this);
        document.addEventListener('cart:refresh', this.onCartChange);
        this.subscribe();
      }

      disconnectedCallback() {
        if (!this.refreshUrl) return;

        document.removeEventListener('cart:refresh', this.onCartChange);
        if (this.unsubscribe) this.unsubscribe();
        this.unsubscribe = null;
        clearTimeout(this.timer);
      }

      // theme.pubsub comes from the deferred theme.js, which normally runs first.
      subscribe() {
        if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
          this.unsubscribe = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartChange);
          return;
        }
        document.addEventListener('DOMContentLoaded', () => {
          if (this.isConnected && !this.unsubscribe && window.theme && theme.pubsub) this.subscribe();
        }, { once: true });
      }

      onCartChange() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.refresh(), 100);
      }

      // The element keeps its identity and takes the fresh box's attributes and contents, so its
      // subscriptions survive. Responses can arrive out of order when the cart changes twice within
      // one fetch: an older one never overwrites a newer one.
      async refresh() {
        const seq = (this.requested = (this.requested || 0) + 1);
        try {
          const response = await fetch(this.refreshUrl, { headers: { Accept: 'text/html' }, cache: 'no-store' });
          if (!response.ok) return;
          const html = await response.text();
          if (!this.isConnected || seq < (this.applied || 0)) return;
          this.applied = seq;

          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('tso-shipping-info');
          if (!fresh) {
            this.remove();
            return;
          }
          for (const name of this.getAttributeNames()) {
            if (!fresh.hasAttribute(name)) this.removeAttribute(name);
          }
          for (const attr of fresh.attributes) this.setAttribute(attr.name, attr.value);
          this.innerHTML = fresh.innerHTML;
        }
        catch (error) {
          // Keep the box as it is; the next cart change tries again.
        }
      }
    }
  );
}
